export default __webpack_public_path__ + "static/media/b_teamwork_small.96d3dbfc.png";